import React, { useCallback, useState } from 'react'
import { Box, Container, IconButton, Typography } from '../imports/muiImport'
import { NavLink, useNavigate } from 'react-router-dom';

import Login from './authPages/Login';
import OTPComponent from './otp/OTPComponent';
import { verifyUserOTPForLogin } from '../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { actionNotifier } from '../components/tostify';
import { userTokenSave } from '../apiCalls/functions';
import { useAuth } from '../hooks/contexts/AuthContext';
import Timer from '../pages/LOGIN_SIGNUP/OTP/Timer';
import { validateOtp } from '../apiCalls/urls/urlFunction';
import { Helmet } from 'react-helmet-async';

const LoginPage = () => {
    const [showOTPForm, setOTPForm] = useState(false);
    const [isResendAvailable, setIsResendAvailable] = useState(false);
    const [otpFormLoading, setOtpFormLoading] = useState(false);
    const [isResetOtp, setIsResetOtp] = useState(false);
    const [isUserAuthentic, setIsUserAuthentic] = useState({});
    const [otpFormTimer, setOtpFormTimer] = useState(60);
    const [noOfUserOTPSend, setNoOfUserOTPSend] = useState(0);

    const { authUser, setAuthUser, isLoggedIn, setIsLoggedIn } = useAuth();
    const navigate = useNavigate();
   

    const handleOtpVerify = async (user_phone, user_otp) => {
        setOtpFormLoading(true);
        const loginResponse = await verifyUserOTPForLogin(user_phone, user_otp);
        if (loginResponse?.status) {
            actionNotifier.success(loginResponse?.data?.message, { position: "top-left", autoClose: 2000 });

            if (isUserAuthentic?.isLoginForm && loginResponse?.data?.data) {
                userLoginSuccessfully(loginResponse?.data?.data);
                setTimeout(() => {
                    navigate('/', { replace: true });
                    setOtpFormLoading(false);
                }, 300);
            } else {
                setTimeout(() => {
                    navigate('/login', { replace: true });
                    setOtpFormLoading(false);
                    setIsResetOtp(true);
                }, 300);
            }
        } else {
            setOtpFormLoading(false);
            setIsResetOtp(true);
        }
    }

    const handleOtpResend = async (mobile) => {
        if (isResendAvailable) {
            const response = await validateOtp(mobile);
            if (response?.status) {
                setNoOfUserOTPSend((prevState) => prevState + 1);
                setOtpFormTimer(() => 60);

                actionNotifier.info("OTP has been resent", { position: "top-left", autoClose: 1000 });
            }
        } else {
            actionNotifier.warning(`Please wait for the timer to resend OTP`, { position: "top-left", autoClose: 1000 });
        }
    }

    const userLoginSuccessfully = async (token) => {

        let loginToken = userTokenSave(token);

        if (loginToken) {
            // Set true User Login Status it will reflect every where
            setIsLoggedIn(true);

            // Notification remove 
            actionNotifier.clearAll();
            navigate("/", { replace: true });
        }
    }

    const timerEnd = () => {
        if (noOfUserOTPSend <= 2) {
            setIsResendAvailable(() => true);
            setOtpFormTimer(() => null);
            setOtpFormLoading(false);
        } else {
            setOtpFormLoading(false);
            setIsResetOtp(true);
            setIsResendAvailable(() => false);
            window.location.reload();
        }
    }


    return (
        <>
            <Helmet>
                <title>Signup -99gift.in</title>
                <meta property="og:title" content="Signup -99gift.in" />
            </Helmet>
            
            {!showOTPForm ?
                <>
                    <Login
                        setOTPForm={setOTPForm}
                        setIsUserAuthentic={setIsUserAuthentic}
                    />

                    <Box sx={{
                        pt: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}>
                        <NavLink to={'/password-reset'} style={{ textDecoration: "none" }}>
                            <Typography variant='subtitle1'
                                sx={{
                                    color: "secondary.main",
                                    fontWeight: 500,
                                }}
                            >
                                Forgot Password ?
                            </Typography>
                        </NavLink>

                        <Typography variant='subtitle1'
                            component={'div'}
                            sx={{
                                color: "textPrimary.main",
                                fontWeight: 400,
                            }}
                        >
                            Don't have an account?
                            <NavLink to={'/signup'} style={{ textDecoration: "none", marginLeft: 3 }}>
                                <Typography variant='subtitle1'
                                    component={'span'}
                                    sx={{
                                        color: "secondary.main",
                                        fontWeight: 500,
                                    }}
                                >
                                    Sign Up
                                </Typography>
                            </NavLink>
                        </Typography>
                    </Box>
                </>
                :
                <>
                    <OTPComponent
                        phone={isUserAuthentic?.mobile}
                        purpose="Login OTP"
                        loading={otpFormLoading}
                        isResendAvailable={isResendAvailable}
                        onVerifyOtp={handleOtpVerify}
                        onResendOtp={handleOtpResend}
                        isResetOtp={isResetOtp}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",

                        }}
                    >
                        <Timer
                            initialTime={otpFormTimer}
                            timeEnd={timerEnd}
                            timerStyle={{}}
                        />
                    </Box>
                </>
            }
        </>
    )
}

export default LoginPage